<template>
    <div class="plan-notes flow__panel flow__container-fixed">
        <div>
            <section class="plan-notes__top">
                <h2>{{ myResources.title }}</h2>
                <p>{{ myResources.introText }}</p>
            </section>
            <section>
                <error-handler class="plan-notes__errors" />
                <plan-notes-form class="plan-notes__form" />
            </section>
            <div class="plan-notes__cta">
                <cta-tile class="plan-notes__cta__tile cta-tile--grid"
                          name="plan-notes"
                          :button-text="commonResources.continue"
                          show-small-image
                          type="cta"
                          breakout-extended
                          @click="onProceed" />
            </div>
        </div>
    </div>
</template>

<script>

import ProgressManager from '@/progress-manager'
import AnalyticsPage from './analytics-page'
import MyHomeDataErrorsDisplay from './my-home-data-errors-display'

import CtaTile from '@/components/app-core/cta-tile'
import ErrorHandler from '@/components/app-core/error-handler'
import PlanNotesForm from '@/components/plan-notes/plan-notes-form'
import ResourcesHelper from '@/components/resources-helper'

export default {

    mixins: [
        AnalyticsPage,
        MyHomeDataErrorsDisplay,
        ResourcesHelper,
    ],

    computed: {
        /**
         * Return the resources object for this page.
         * @return {PlanNotesResources}
         */
        myResources() {
            return this.parseResources('views.planNotes')
        },
    },

    methods: {
        /**
         * Move to next route.
         */
        onProceed() {
            this.$router.push(ProgressManager.getNext(this.$route.name))
        },
    },

    components: {
        CtaTile,
        ErrorHandler,
        PlanNotesForm,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\views\_plan-notes.scss

.plan-notes {
    @include element('cta') {
        @include bp-min-mid {
            max-width: 160px;
        }
    }
}

</style>
